import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_FORGOTPASSWORDVERIFY_FULFILLED = "FETCH_FORGOTPASSWORDVERIFY_FULFILLED";
export const FETCH_FORGOTPASSWORDVERIFY_REJECTED = "FETCH_FORGOTPASSWORDVERIFY_REJECTED";
export const FETCH_FORGOTPASSWORDVERIFY_PENDING = "FETCH_FORGOTPASSWORDVERIFY_PENDING";

export function forgotPasswordVerify(code, password) {
    return async (dispatch) => {
        dispatch({ type: FETCH_FORGOTPASSWORDVERIFY_PENDING });

        const nationalIdentifier = localStorage.getItem("nationalIdentifier");
        const data = JSON.stringify({
            nationalIdentifier: nationalIdentifier,
            verificationCode: code,
            password: password
        });

        try {
            const response = await axios.post(`${API_BASE}/api/v3/auth/complete-forgot-password`, data, {
                headers: {
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("Client-Id"),
                    "One-Id": localStorage.getItem("One-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            });

            dispatch({
                type: FETCH_FORGOTPASSWORDVERIFY_FULFILLED,
                payload: response.data
            });

            return response.data; // Başarı durumunda geri döndür
        } catch (error) {
            console.error("Şifre sıfırlama hatası:", error);

            let errorMessage = "Şifre değiştirme işlemi başarısız oldu!";

            if (error.data && error.data) {
                errorMessage = error.data.responseMessage || errorMessage;
            }

            dispatch({
                type: FETCH_FORGOTPASSWORDVERIFY_REJECTED,
                payload: errorMessage
            });

        }
    };
}
